export function normalizeIeltsReadingData(apiResponse) {
  const passageMap = new Map();
  const questionOrderMap = {};
  let globalNumber = 1;

  const NO_PASSAGE_ID = "NO_PASSAGE";

  apiResponse.questions.forEach((q) => {
    // 1️⃣ Resolve passage
    const passage = q.passage?.[0] ?? {
      id: NO_PASSAGE_ID,
      title: "Questions without passage",
      content: null,
    };

    if (!passageMap.has(passage.id)) {
      passageMap.set(passage.id, {
        passage_id: passage.id,
        passage_title: passage.title,
        content: passage.content,
        sections: new Map(), // group by instruksi
      });
    }

    const passageEntry = passageMap.get(passage.id);

    // 2️⃣ Resolve instruksi (IMPORTANT)
    const instruksiObj = q.instruksi?.[0];
    const instruksiId = instruksiObj?.id ?? "GENERAL";
    const instruksiTitle =
      instruksiObj?.direction ?? "Answer the following questions";

    if (!passageEntry.sections.has(instruksiId)) {
      passageEntry.sections.set(instruksiId, {
        instruksi_id: instruksiId,
        instruksi_title: instruksiTitle,
        questions: [],
      });
    }

    passageEntry.sections.get(instruksiId).questions.push({
      id: q.id,
      question_text: q.question_text,
      question_type: q.question_type,
      options: q.options?.map((opt, index) => ({
        ...opt,
        optionIndex: index + 1,
      })),
    });
  });

  // 3️⃣ Convert Maps → Arrays & number questions globally
  const parts = Array.from(passageMap.values()).map((passage, passageIndex) => {
    const sections = Array.from(passage.sections.values()).map(
      (section, sectionIndex) => {
        section.questions.sort((a, b) => a.id - b.id);

        const startNumber = globalNumber;

        section.questions = section.questions.map((q, questionIndex) => {
          questionOrderMap[q.id] = {
            number: globalNumber,
            passageIndex,
            sectionIndex,
            questionIndex,
          };

          return {
            ...q,
            number: globalNumber++,
          };
        });

        return {
          ...section,
          startNumber,
          endNumber: globalNumber - 1,
        };
      }
    );

    return {
      passage_id: passage.passage_id,
      passage_title: passage.passage_title,
      content: passage.content,
      sections,
    };
  });

  return {
    parts,
    total_questions: globalNumber - 1,
    questionOrderMap,
  };
}
